import { repositories } from './http-repositories'

export { repositories }
export const taskRepository = repositories.tasks
export const accountBatchRepository = repositories.accountBatches
export const commerceRepository = repositories.commerce
export const creditRepository = repositories.credits
export const developerRepository = repositories.developer
export type {
  AccountBatchRepository,
  CommerceRepository,
  CreditRepository,
  DeveloperRepository,
  TaskRepository,
} from '../contracts/repositories'
